/*
	JavaScript equivalent of the Haversine formula
	source: https://cloud.google.com/blog/products/maps-platform/how-calculate-distances-map-maps-javascript-api
*/
const getDistanceBetweenTwoLocations = (mk1, mk2) => {
  var R = 6371.071; // Radius of the Earth in km
  var rlat1 = mk1.latitude * (Math.PI / 180); // Convert degrees to radians
  var rlat2 = mk2.latitude * (Math.PI / 180); // Convert degrees to radians
  var difflat = rlat2 - rlat1; // Radian difference (latitudes)
  var difflon = (mk2.longitude - mk1.longitude) * (Math.PI / 180); // Radian difference (longitudes)

  var d =
    2 *
    R *
    Math.asin(
      Math.sqrt(
        Math.sin(difflat / 2) * Math.sin(difflat / 2) +
          Math.cos(rlat1) * Math.cos(rlat2) * Math.sin(difflon / 2) * Math.sin(difflon / 2),
      ),
    );

  return Math.round(d * 10) / 10;
};

export default getDistanceBetweenTwoLocations;
